export default [
  {
    id: 1,
    user: {
      name: "Ernie Carswell",
      role: "Founder, Earnie Carswell & Associates",
      avatarUrl: "/images/testimonials/ernie-carswell.jpg",
    },
    content:
      "My coach has transformed my business, improved my efficiency, and introduced me to strategies that booted my production. I highly recommend Forward Coaching for anyone seeking impactful business coaching, whether you’re new or a seasoned professional.",
    source: "Forward Coaching",
    placeUrl:
      "https://forwardcoaching.com/real-estate-coaching/?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-FC-button",
    brivityUrl:
      "https://forwardcoaching.com/real-estate-coaching/?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=BP-FC-button",
  },
  {
    id: 2,
    user: {
      name: "Kallie Moulton",
      role: "Director of Operations, Landy Frost Group",
      avatarUrl: "/images/testimonials/kallie-moulton.jpg",
    },
    content:
      "Our Brivity Virtual Assistant hit the ground running, allowing me to focus on building systems and training. I’m no longer working late nights, and our business is growing stronger than ever.",
    source: "Brivity VA",
    placeUrl:
      "https://brivityva.com?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-BVA-button",
    brivityUrl:
      "https://brivityva.com/?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=BP-BVA-button",
  },
  {
    id: 3,
    user: {
      name: "Junior Ibarra",
      role: "Team Lead, Team IRG",
      avatarUrl: "/images/testimonials/junior-ibarra.jpg",
    },
    content:
      "Brivity Connect’s lead gen and retargeting campaigns have been a game changer for us—over half of our closings came directly from the ads we’re running with them. The Facebook campaigns are filling our pipeline with hot leads we’re actively nurturing.",
    source: "Brivity Leads",
    placeUrl:
      "https://www.brivity.com/real-estate-leads?utm_campaign=AO-Product-AddOns-PLACE&utm_source=in-app&utm_medium=organic&utm_term=learn-more&utm_content=PLACE-BrivityLeads-button",
    brivityUrl:
      "https://www.brivity.com/real-estate-leads?utm_campaign=AO-Product-AddOns-BP&utm_source=in-app&utm_medium=organic&utm_term=get-more-leads&utm_content=BP-BrivityLeads-button",
  },
  {
    id: 4,
    user: {
      name: "Tracy Robertos",
      role: "Team Lead, Atlas Home Team",
      avatarUrl: "/images/testimonials/tracy-robertos.jpg",
    },
    content:
      "Within just 24 hours of using Recruiter.ai, I successfully signed a licensed agent to join my team.",
    source: "Recruiter.ai",
    replace: true,
    placeUrl: "/launch?slug=brivity-recruiter",
    brivityUrl: "/add_ons/recruiter_ai",
  },
  {
    id: 5,
    user: {
      name: "Vija Williams",
      role: "Team Lead, Vija Real Estate ",
      avatarUrl: "/images/testimonials/vija-williams.jpg",
    },
    content:
      "In 8 months, after just two hours learning Recruiter.ai, we recruited 15 agents and are on track to grow to 25.",
    source: "Recruiter.ai",
    replace: true,
    placeUrl: "/launch?slug=brivity-recruiter",
    brivityUrl: "/add_ons/recruiter_ai",
  },
];
